module.exports = __webpack_public_path__ + "img/1721783990050-WhatsApp Image 2024-07-24 at 09.18.22.jpeg.dc24639f.webp";